import jwtDecode from 'jwt-decode';
import { getAuthCookie } from './Utils';

const getUserFromToken = () => {
  const token = getAuthCookie();

  if (!token) return {};

  try {
    return jwtDecode(token);
  } catch (error) {
    console.error('Error decoding JWT for Salesforce bot context:', error);
    return {};
  }
};

export const getSalesforceHiddenPrechatFields = (user = {}) => {
  const tokenUser = getUserFromToken();

  const roles = user.roles || tokenUser.realm_access?.roles || [];
  const permissions =
    user.permissions ||
    tokenUser.permissions ||
    tokenUser.resource_access?.account?.roles ||
    [];

  return {
    CUITCUIL: user.cuit || tokenUser.cuit || '',
    EMAIL:
      user.email ||
      user.preferred_username ||
      tokenUser.preferred_username ||
      '',
    ROL: roles.join(','),
    PERMISOS: permissions.join(','),
  };
};

export const setSalesforceHiddenPrechatFields = (user) => {
  if (!window.embeddedservice_bootstrap?.prechatAPI) return;

  const hiddenPrechatFields = getSalesforceHiddenPrechatFields(user);

  window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields(
    hiddenPrechatFields
  );
};
